import 'ui-core/components/accordion/js/accordion';

var $body = $('body');

//UX.accordion.hideAllBoolean = false;

UX.accordion.collapseAccordion = false;

UX.accordion.additionalControls = function () {
    $body.on('click', '.toc-item__footer .accordion__control', function (e) {
        var $parentItem = $(this).parents('.issue-item,.search__item .item__body');

        if ($parentItem) {
            if ($(this).hasClass('js--open')) {
                $parentItem.addClass('extra-box-shadow');
            } else {
                $parentItem.removeClass('extra-box-shadow');
            }
        }
    });
};
